import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from 'antd';
import { userCreate } from '../../api/accounts';
import SignUpForm, { SignUpInfo } from '../../components/SignUpForm';
import MainLayout from '../../components/MainLayout';
import StatusMessages, { StatusMessage } from '../../components/StatusMessages';
import { SIGN_UP_REDIRECT_ROUTE } from '../../config/constants';
import styles from './SignUp.module.css';

export interface SignUpProps {
  statusMessages?: StatusMessage[]
};

// user sign up page
const SignUp = (props: SignUpProps): JSX.Element | null => {
  // list of status messages to display
  const [statusMessages, setStatusMessages] = useState<StatusMessage[]>(props.statusMessages ?? []);
  const navigate = useNavigate();

  // set document title
  useEffect(() => {
    document.title = 'Sign Up | Sigmoid Academy';
  }, []);

  // handle sign up
  const handleSignUp = async (info: SignUpInfo): Promise<void> => {
    // clear status messages
    setStatusMessages((previousMessages: StatusMessage[]) => []);

    try {
      await userCreate(info.username, info.email, info.password);
      navigate(
        SIGN_UP_REDIRECT_ROUTE,
        {
          state: {
            email: info.email,
            statusMessages: [
              {
                message: 'Account created successfully',
                status: 'success'
              },
              {
                message: 'Please check your email to verify your account',
                status: 'warning'
              }
            ]
          }
        }
      );
    } catch(error: any) {
      // collect list of error messages from response
      let errorStatusMessages: StatusMessage[] = [];
      for (let field in error.response?.data as any) {
        let messages = (error.response?.data as any)[field];

        for (let i = 0; i < messages.length; i++) {
          errorStatusMessages.push({
            message: messages[i].charAt(0).toUpperCase() + messages[i].slice(1),
            status: 'error',
          });
        }
      }

      // set list of errors as status messages
      setStatusMessages((previousMessages: StatusMessage[]) => [...errorStatusMessages]);
    };
  };

  return (
    <div>
      <MainLayout selectedKey='signup'>
        <div className={styles.mainContainer}>
          <Typography.Title
            level={1}
            className={styles.mainHeading}
          >
            Sign Up
          </Typography.Title>
          <StatusMessages items={statusMessages} />
          <SignUpForm handleSignUp={handleSignUp} />
        </div>
      </MainLayout>
    </div>
  );
};

export default SignUp;
